module.exports = __webpack_public_path__ + "static/media/ec19b3e4-43e3-4bd3-af04-7fb5781f8cb6.32cc66ce.JPG";